import { AgentPriceWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AgentPriceWebService.Configuration
});

export default config;
